import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './778947f91be5e50ebdfb691e3e7b2ba38c07c4298e845a0da9fb11af3f9a072c.cfe-internal.js';

var _excluded = ["children", "className", "isSelected", "isHighlightedOnHover", "isHighlighted"];
var FlyoutOption = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$isHighlightedOnH = _ref.isHighlightedOnHover,
    isHighlightedOnHover = _ref$isHighlightedOnH === void 0 ? false : _ref$isHighlightedOnH,
    _ref$isHighlighted = _ref.isHighlighted,
    isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React__default.createElement("div", _extends({}, rest, {
      ref: ref,
      className: classNames(className, styles.flyoutOption, _defineProperty(_defineProperty(_defineProperty({}, styles.hoverHighlight, isHighlightedOnHover), styles.highlighted, isHighlighted), styles.selected, isSelected)),
      role: "option",
      "aria-selected": isSelected
    }), children)
  );
});

export { FlyoutOption };
